<template>
  <div id="basic">
    <div class="top_div_update">
      <div class="top_div_updates">
        <el-form
          :label-position="labelPosition"
          label-width="120px"
          :model="datalist"
          v-loading="listloading"
          :rules="rules"
          ref="datalist"
        >
          <el-form-item label="名称" prop="name">
            <el-input class="inpit_update" v-model="datalist.name"></el-input>
          </el-form-item>
          <el-form-item label="省份" prop="province">
            <el-input class="inpit_update" v-model="datalist.province"></el-input>
          </el-form-item>
          <el-form-item label="城市" prop="city">
            <el-input class="inpit_update" v-model="datalist.city"></el-input>
          </el-form-item>
          <el-form-item label="区域" prop="district">
            <el-input class="inpit_update" v-model="datalist.district"></el-input>
          </el-form-item>

           <el-form-item label="外卖下单(配送)" prop="district">
            <!-- <el-input class="inpit_update" v-model="datalist.can_delivery"></el-input> -->
              <el-switch
              v-model="datalist.can_delivery"
              active-color="#ff4949"
              active-text="关闭"
              inactive-text="开启"
              inactive-color="#13ce66">
            </el-switch>

            <!-- false 为开启  true关闭 -->
         
         </el-form-item>

          
          <el-form-item label="详细地址" prop="address">
            <el-input class="inpit_update" v-model="datalist.address"></el-input>
          </el-form-item>
          <el-form-item label="联系方式" prop="contact_number">
            <el-input class="inpit_update" v-model="datalist.contact_number"></el-input>
          </el-form-item>
          <el-form-item label="营业时间" prop="at">
            <div class="inpit_update">
              <el-time-select
                placeholder="起始时间"
                style="margin-bottom:10px"
                v-model="datalist.open_time_from"
                :picker-options="picker"
              ></el-time-select>
              <el-time-select
                placeholder="结束时间"
                v-model="datalist.open_time_to"
                :picker-options="picker"
              ></el-time-select>
            </div>
          </el-form-item>
          <el-form-item size="large">
            <el-button type="primary" @click="submitForm('datalist')">提交</el-button>
            <el-button @click="goBasic">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import fecha from 'element-ui/src/utils/date';
export default {
  data() {
    var atItem = (rule, value, callback) => {
      console.log(rule, value, callback, this.datalist, 'xxxxx');
      if (!this.datalist.open_time_from) {
        return callback(new Error('营业开始时间不能为空'));
      }
      if (!this.datalist.open_time_to) {
        return callback(new Error('营业结束时间不能为空'));
      }
      callback();
    };
    return {
      labelPosition: 'right',
      listloading: false,
      datalist: {
        address: null,
        // open_time: null,
        images: [],
        city: null,
        province: null,
        name: null,
        // pay_wait_time: null,
        contact_number: null,
        open_time_from: '',
        open_time_to: '',
        can_delivery:false,
      },
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      fileList: [],

      picker: {
        start: '00:00',
        step: '00:15',
        end: '23:59',
      },
      rules: {
        at: [
          { required: true, validator: atItem, trigger: 'blur' },
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' },
        ],
        name: [
          { required: true, message: '店铺名称不能为空', trigger: 'blur' },
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' },
        ],
        user_name: [
          { required: true, message: '用户名不能为空', trigger: 'blur' },
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' },
        ],
        passwd: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' },
        ],
        invite_code: [
          { required: true, message: '邀请码不能为空', trigger: 'change' },
        ],
          can_delivery: [
          { required: false, message: '请选择', trigger: 'change' },
        ],

        province: [
          { required: true, message: '省份不能为空', trigger: 'blur' },
        ],
        address: [
          { required: true, message: '详细地址不能为空', trigger: 'blur' },
        ],
        contact_person: [
          { required: true, message: '联系人不能为空', trigger: 'blur' },
        ],
        contact_number: [
          { required: true, message: '联系方式不能为空', trigger: 'blur' },
        ],
        city: [
          {
            required: true,
            message: '城市不能为空',
            trigger: 'blur',
          },
        ],
        district: [
          {
            required: true,
            message: '地区不能为空',
            trigger: 'blur',
          },
        ],
      },
    };
  },
  methods: {
    submitForm(formName) {
      console.log(this.datalist);
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.onSubmit();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    getList() {
      if (!this.$route.params.id) {
        return;
      }
      let data = JSON.parse(localStorage.getItem('basics_min'));
      data.created_at = fecha.format(
        new Date(data.created_at),
        'yyyy-MM-dd HH:mm:ss'
      );
      data.updated_at = fecha.format(
        new Date(data.updated_at),
        'yyyy-MM-dd HH:mm:ss'
      );
      if (data.deleted_at) {
        data.deleted_at = fecha.format(
          new Date(data.deleted_at),
          'yyyy-MM-dd HH:mm:ss'
        );
      }
      console.log();
      this.datalist = data;
    },

    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },

    onSubmit() {
      if (!this.$route.params.id) {
        console.log(this.datalist);
        this.pushubmit();
        return;
      }
      this.setubmit();
    },
    setubmit() {
      const {
        can_delivery,
        address,
        city,
        province,
        name,
        open_time_from,
        open_time_to,
        contact_number,
        district,
      } = this.datalist;

      const data = {
        id: +this.$route.params.id,
        address,
        district,
        can_delivery,
        city,
        province,
        name,
        open_time_from,
        open_time_to,
        contact_number,
      };

      const url = this.$userList.user_restaurants;
      this.$http.put(url, data).then(res => {
        this.listloading = false;
        if (res.code === 200) {
          this.$router.push({ path: '/shop/basic' });
        } else {
          //res.message && this.$alert(res.message);
        }
        console.log(res);
      });
    },
    pushubmit() {
      const {
        can_delivery,
        address,
        city,
        province,
        name,
        open_time_from,
        open_time_to,
        contact_number,
        district,
      } = this.datalist;
      const data = {
        address,
        can_delivery,
        district,
        city,
        province,
        name,
        open_time_from,
        open_time_to,
        contact_number,
      };
      const url = this.$userList.user_restaurants;
      this.$http.post(url, data).then(res => {
        this.listloading = false;
        if (res.code === 200) {
          this.$router.push({ path: '/shop/basic' });
        } else {
          //res.message && this.$alert(res.message);
        }
        console.log(res);
      });
    },
    goBasic() {
      this.$router.go(-1);
    },
  },
  created() {
    this.$root.setheadName();
    this.getList();
  },
};
</script>

<style scoped>
#basic {
  width: 100%;
  height: 100%;
  position: relative;
}
.top_div_updates {
  width: auto;
}
.top_div_update {
  width: 100%;
  height: auto;
  box-sizing: border-box;
  padding: 20px;
  background: #fff;
  margin-bottom: 20px;
  min-height: 200px;
  display: flex;
  justify-content: center;
}
.inpit_update {
  width: 500px;
  display: flex;
  flex-direction: column;
}
.img_class_up {
  width: 500px;
}
.update_s {
  margin-right: 20px;
  display: flex;
}
</style>
